import BaseService from "../CorBase/BaseService";
import BaseFilter from '../CorBase/BaseFilter';

export class AccountService extends BaseService{
	constructor() {
		super('/Account');
	}


	public freezeAccount(id: number, templates: any) {
		return super.updateBase(this._resourceName + '/freeze-account/' + id, templates);
	}

	public activateAccount(id: number, templates: any) {
		return super.updateBase(this._resourceName + '/activate-account/' + id, templates);
	}

	public getAllByFilter(filter: AccountFilter) {
		return super.getAllByFilterBase(filter);
	}
}

export class AccountFilter extends BaseFilter{
	constructor(idTenant?: number | null, inPriceList?: boolean | null  ) {
		super();
		this._idTenant = idTenant;
		this._inPriceList = inPriceList;
	}

	private _idTenant?: number | null;
	private _inPriceList?: boolean | null;

	public getAllParams(): {} {
		let data = Object.assign({},
			(this._idTenant != null ? { IdTenant: this._idTenant } : {}),
			(this._inPriceList != null ? { InPriceList: this._inPriceList } : {})

		);
		
		return data;
	};
}